export const ERROR_VALIDACION_CONTACTO = "Dato ingresado no válido";
